<template>
  <div 
    class="TagNavPanel"
    :class="classList" 
    v-if="active">

    <div class="TagNavPanel__header" @click="onClick">
      <div>
        {{ label }}
      </div>
      <div class="TagNavPanel__count">
        {{ count }}
      </div>
    </div>
    <font-awesome-icon 
        :icon="['fal', 'times-circle']" 
        @click="closeClick" />
  </div>
</template>

<script>
export default {
  name: 'TagNavPanel',
  computed: {
    filter() {
      return this.$store.getters.getFilters;
    },
    active() {
      return ! ['', null, 'off'].includes(this.filter);
    },
    slug() {
      return this.filter.split('--')[1];
    },
    data() {
      if (this.type === 'thema') {
        return this.$store.getters.getThemaBySlug({slug: this.slug});
      } else {
        return this.$store.getters.getPartijBySlug({slug: this.slug});
      }
    },
    label() {
      if (this.data) {
        return this.data.name;
      }
      return '';
    },
    category() {
      return this.filter.split('--')[0];
    },
    type() {
      return this.category === 'thema' ? 'thema' : 'partij';
    },
    count() {
      let count = '';
      if (this.type == 'thema') {
        count = (this.$store.getters.getProjectIdsByThema({id: this.data.id})).length - 1;
      } else {
        count = (this.$store.getters.getProjectIdsByPartij({id: this.data.id})).length - 1;
      }
      if (count === 0) {
        return 'Geen verbindingen';
      }
      if (count === 1) {
        return '1 verbinding';
      }
      return count+' verbindingen';
    },
    classList() {
      let list = {};
      list['TagNavPanel--'+this.category] = true;
      return list;
    }
  },
  methods: {
    onClick() {
      let route = false;
      if (this.type === 'thema') {
        // TODO: Toch Thema pagina toevoegen ?
        // route = { name: 'thema-beknopt', params: { slug: this.slug } }
      } else {
        route = { name: 'partij-beknopt', params: { slug: this.slug } }
      }

      if (route) {
        this.$router.push(route);
      }
    },
    closeClick() {
      if (this.$store.map) {
        this.$store.map.setFilter('connections', ['==', 'type', 'off'])
        this.$store.dispatch('setFilters', {
          filters: `off`
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .TagNavPanel {
    background: white;
    // color: $color_primary;
    color: #F1BE61;
    z-index: 99999999;
    opacity: 0.99;
    /* width: 293px; */
    position: absolute;
    left: 220px;
    right: 0;
    top: 0;
    max-width: 400px;
    margin: auto;
    padding: 16px 32px;
    text-align: center;
    box-shadow: 0 0.125rem 0.8125rem rgba(0, 0, 0, 0.28);
    text-transform: capitalize;
    font-family: $font-nav;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    user-select: none;

    &__header {
      width: 100%;
      display: flex;
      cursor: pointer;
      flex-direction: column;

      div {
        flex-grow: 1;
        text-align: center;
      }
    }
    &__count {
      width: 100%;
      text-align: center;
      margin-top: 8px;
    }

    svg {
      cursor: pointer;
    }

    &--thema {
      color: $metro_oranje;
    }
    &--bouw {
      color: $metro_geel;
    }
    &--kennis {
      color: $metro_blauw;
    }
    &--leverancier {
      color: $metro_groen;
    }
    &--gemeente {
      color: $metro_rood;
    }
    &--corporatie {
      color: $metro_paars;
    }

  }
</style>
